<script>
    import app from "../../stores/app";
    import {fade, fly} from 'svelte/transition';
    import {clickOutside} from "../../lib/clickOutside";
    import {createEventDispatcher} from 'svelte/internal';
    import Icon from "../../components/Icon.svelte";
    import CloseButton from "../../components/CloseButton.svelte";

    export let title = '';
    export let modalMd = false;
    export let showCloseButton = true;
    export let closeOnClickOutside = false;
    export let closeOnEscape = true;
    export let visible = true;
    export let bodyClass = '';

    let nowState = false;

    const dispatch = createEventDispatcher();

    const handleClickOutside = () => {
        if (closeOnClickOutside) {
            close();
        }
    }

    const close = () => {
        visible = false;
        if (closeOnEscape) {
            app.removeEscapeEventHandler();
        }
        setTimeout(() => {
            dispatch('close');
        }, 200);
    }

    $: if (nowState != visible && closeOnEscape) {
        if (visible) {
            if (closeOnEscape) {
                app.addEscapeEventHandler(close);
            }
            nowState = visible;
        }
    }
</script>
{#if visible}
    <div class="modal-overlay" id="moooodal" transition:fade="{{ duration: 100 }}" use:clickOutside
         on:click_outside="{ handleClickOutside }">
        <div class="wrapper">
            <div class="panel modal-panel" class:modal-md={ modalMd } in:fly="{{ y: -20, duration: 200 }}">
                <div class="panel-heading panel-pad">
                    <div class="title">
                        { title }
                    </div>
                    {#if showCloseButton}
                        <CloseButton on:click="{ close }"/>
                    {/if}
                </div>
                <div class="panel-body panel-pad { bodyClass }">
                    <slot name="body"/>
                </div>
                <slot name="footer"/>
            </div>
        </div>
    </div>
{/if}

<style>
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9000;
        overflow-y: auto;
    }

    .modal-overlay .wrapper {
        position: absolute;
        width: 100%;
        padding: 10px 0;
    }

    .modal-panel {
        width: max-content;
        background: #fff;
        border-radius: 2px;
        padding-top: 5px;
        transition: .3s all ease;
        margin: 0 auto;
    }

    .modal-md {
        width: 800px;
    }


    @media (max-width: 576px) {
        .modal-panel {
            width: calc(100vw - 20px);
        }
    }

    @media (min-width: 992px) {
        .modal-panel {
            min-width: 450px;
        }
    }

    @media (min-width: 1200px) {
        .modal-overlay .wrapper {
            padding: 30px 0;
        }
    }
</style>